import { render, staticRenderFns } from "./AsientoTipoDetalleItem.vue?vue&type=template&id=29b0e7c7&scoped=true&"
import script from "./AsientoTipoDetalleItem.vue?vue&type=script&lang=js&"
export * from "./AsientoTipoDetalleItem.vue?vue&type=script&lang=js&"
import style0 from "./AsientoTipoDetalleItem.vue?vue&type=style&index=0&id=29b0e7c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b0e7c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
